import { createSelector } from 'reselect'

export const getLoginInPopupError = createSelector(
  (state) => state && state.user && state.user.auth && state.user.auth.formErrors && state.user.auth.formErrors.loginInPopup
    ? state.user.auth.formErrors.loginInPopup
    : null,
  (items) => items
)
